import React, { Fragment } from 'react';
import { Card, Col, Container, Row, Button, CardBody, Table, ButtonGroup, Badge, Input } from 'reactstrap';
import { useCompanies } from '../../../hooks/companies/useCompanies';
import { CompaniesList } from '../../../constant';
import { ModalCompany } from '../../../components/companies/ModalCompany';
import { ModalSendEmail } from '../../../components/companies/ModalSendEmail';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TitleDataTable } from '../../../components/tableDataTable/TitleDataTable';
import { DialogImgMicrositeCompany } from './DialogImgMicrositeCompany';

export const IndexCompanies = () => {

    const {
        companies, states, companyTurn, listTaxRegime,
        method, handleInputChange, handlePickerValues,
        handleSelectValues, validaciones,
        id_company_turn, code, name, is_maquila,
        customer_since, send_results_pacient,
        category, is_block, consecutive_number,
        results_email, logo, microsite, username, imageLogo,
        payment_by_company, payment_by_patient,
        require_invoice, available_invoice_patient, credit_days,
        toggle, modal, modalTitle, loading,
        handleChangePaymentBy,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleChangeState,
        previewLogo, imageHandler,
        handleAddCompany,
        listCompanyBusinessNames, handleDinamicInputRFC,
        arrayMunicipality, removeAlterCompanies,
        totalPageCount, currentPage, nextPage, previousPage, goToPage, handleSearchCompany,
        //new micro
        is_requirements, requirements, on_check_req_especial, password_microsite, stamp_invoice,
        // ? SEND EMAIL
        handleSendEmail, modalEmail, toggleEmail, email, saveEmail, validacionesEmail, handleInputChangeWithPrefix,
        micrositeCode, generateRandomPassword, numberItems, closeModalCompanies, closeModalEmailCompanies,
        searchCompany, handleClearFilter,

        //excel
        handleExportExcel, loadingExport,
        // * COMPANY BUSSINESS
        handleNewBussines, handleAddressInput, handleDeleteAddress,

        closeDialogMicrosite, handleCreateMicrosite, modalMicrosite, uploadImage,
        fileUploadRef, validateAndUpload, MAX_SIZE

    } = useCompanies();

    let _microsite = localStorage.getItem('configuration_microsite');


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const centerStyle = {
        ...cellStyle,
        textAlign: "center",
    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                {rowData.microsite && (
                    <button
                        type="button"
                        onClick={() => handleSendEmail(rowData.id_company)}
                        style={{
                            padding: "2px",
                            fontSize: "1rem",
                            height: "26px",
                            width: "26px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#ffb900",
                            border: "none",
                            color: "#fff"
                        }}
                        title="Enviar a correo"
                    >
                        <i className="icofont icofont-envelope" />
                    </button>
                )}

                <Button
                    color="primary"
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_company)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}

                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button
                    color="danger"
                    size="sm"
                    onClick={() => handleDelete(rowData.id_company)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };



    return (
        <Fragment>
            <div className='container-global-zoom'>
                <Row>
                    <Col md="12">
                        <Card>
                            <CardBody className="p-1">
                                <div className="table-responsive">
                                    <Col sm="12" className='p-l-0 p-r-0 pb-2 pt-3' >
                                        <TitleDataTable
                                            titleTable={CompaniesList}
                                            buttonActions={handleExportExcel}
                                            titleButton="Descargar listado de clientes"
                                            isDisbled={loadingExport}
                                            loadingIsDisabled={loadingExport}
                                            titleCreate="Crear Cliente"
                                            buttonActionsCreate={handleCreate}
                                            actionInput={handleSearchCompany}
                                            valueFilter={searchCompany}
                                            filterLocalStorage={true}
                                            cleanFilterLocalStorage={handleClearFilter}
                                            {...(_microsite === "True" && {
                                                microsite: true,
                                                titleButtonMicrosite: "Imagen para micrositio (Login)",
                                                buttonMicrosite: handleCreateMicrosite
                                            })}
                                        />
                                    </Col>

                                    <DataTable
                                        value={companies}
                                        paginator
                                        rows={numberItems}
                                        first={(currentPage - 1) * numberItems}
                                        totalRecords={companies.length}
                                        onPage={(e) => goToPage(e.page + 1)}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        responsiveLayout="scroll"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img
                                                    src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                                                    style={{ width: "32%" }}
                                                    alt="Sin resultados"
                                                />
                                                <br />
                                                <p className="badge badge-light-primary mt-2" style={{ fontSize: "15px" }}>
                                                    No se encontraron resultados.
                                                </p>
                                            </div>
                                        }
                                    >

                                        <Column header="#" body={(rowData, options) => { const globalIndex = options.rowIndex; return globalIndex + 1; }} headerStyle={headerStyle} style={centerStyle} />
                                        <Column field="code" header="Código" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name" header="Nombre" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="rfc" header="RFC" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="name_company_turn" header="Giro" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="label_category" header="Categoría" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="icon_block" header="Bloqueo" headerStyle={headerStyle} style={cellStyle} />
                                        <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={centerStyle} />

                                    </DataTable>

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>

            <ModalCompany
                {
                ...{
                    modal, toggle, modalTitle, method, loading,
                    states, companyTurn, listTaxRegime,
                    handleInputChange, handlePickerValues, handleSelectValues, validaciones,
                    id_company_turn, code, name, is_maquila, customer_since,
                    send_results_pacient, results_email, logo,
                    is_block, consecutive_number, microsite,
                    username, payment_by_company, payment_by_patient,
                    require_invoice, available_invoice_patient, credit_days,
                    imageLogo, imageHandler,
                    saveCreate, saveUpdate, saveDelete,
                    handleChangePaymentBy,
                    handleChangeState,
                    previewLogo, category,
                    handleAddCompany,
                    listCompanyBusinessNames, handleDinamicInputRFC, removeAlterCompanies,
                    is_requirements, requirements, on_check_req_especial, password_microsite, stamp_invoice, handleInputChangeWithPrefix, micrositeCode,
                    generateRandomPassword, handleNewBussines, handleAddressInput, handleDeleteAddress, closeModalCompanies
                }
                }
            />
            <ModalSendEmail
                {
                ...{ modalEmail, toggleEmail, email, handleInputChange, saveEmail, validacionesEmail, loading, closeModalEmailCompanies }
                }

            />

            <DialogImgMicrositeCompany
                {
                ...{ modalMicrosite, closeDialogMicrosite, uploadImage, fileUploadRef, validateAndUpload, MAX_SIZE }
                }

            />


        </Fragment>
    )
}
